import { useForm } from "react-hook-form";

import { InputDateControllerVertical } from "@components";
import { useQueries } from "@hooks/useQueries";

export const TableFilter = ({ handleQuery }: { handleQuery: any }) => {
  const { register, control } = useForm();
  const { handleQuery: setQueryParam } = useQueries();

  return (
    <div className="bg-light rounded p-10 mb-10">
      <div className="row pb-0 mb-0">
        <InputDateControllerVertical
          label="REPORTS.RESIGNATION_REPORTS.FILTERS.START_DATE"
          control={control}
          name="startDate"
          register={register}
          cols={6}
          onSelectDate={(date) => {
            handleQuery("startDate", date);
            setQueryParam("startDate", date.toString());
          }}
          portal
        />
        <InputDateControllerVertical
          label="REPORTS.RESIGNATION_REPORTS.FILTERS.END_DATE"
          control={control}
          name="endDate"
          register={register}
          cols={6}
          onSelectDate={(date) => {
            handleQuery("endDate", date);
            setQueryParam("endDate", date.toString());
          }}
          portal
        />
      </div>
    </div>
  );
};
